export default "__VITE_ASSET__3561996a__"